import { BaseIcon, BaseIconProps } from './BaseIcon';

export const ZapGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="zapGrad" {...props}>
    <path 
      d="M13 2L3 14h8l-1 8 10-12h-8l1-8z" 
      stroke="url(#zapGrad)" 
      fill="url(#zapGrad)"
      fillOpacity="0.2"
    />
  </BaseIcon>
);
